// extracted by mini-css-extract-plugin
export default {"text-divider":"Gziqkk","textDivider":"Gziqkk","text-divider-line":"EKJjnw","textDividerLine":"EKJjnw"};